import { memo } from "react";
import { NodeResizer, NodeToolbar, Position } from "reactflow";
import { RotateCcw, RotateCw, Trash2 } from "lucide-react";
import { StickerArt } from "./StickerArt";

const ToolBtn = ({ testid, onClick, label, children, danger }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    title={label}
    aria-label={label}
    className={`w-8 h-8 grid place-items-center rounded-full transition-colors ${
      danger ? "text-[#C9286F] hover:bg-[#FCE4F0]" : "text-[#5E4B70] hover:bg-[#EDE7FE]"
    }`}
  >
    {children}
  </button>
);

function StickerNode({ id, data, selected }) {
  const sid = data.stickerId;
  return (
    <div data-testid={`sticker-${sid}`} className="w-full h-full sticker-pop">
      <NodeResizer
        isVisible={selected}
        keepAspectRatio
        minWidth={24}
        minHeight={24}
        maxWidth={400}
        maxHeight={400}
        color="#E0478A"
        handleClassName="!w-3 !h-3 !rounded-full !bg-white !border-2 !border-[#E0478A]"
        onResizeEnd={(_, p) => data.onResize(sid, p)}
      />
      <NodeToolbar isVisible={selected} position={Position.Top} offset={10}>
        <div
          data-testid={`sticker-toolbar-${sid}`}
          className="flex items-center gap-0.5 bg-white border-2 border-[#F5D0E3] rounded-full px-1.5 py-1 shadow-[0_6px_20px_rgba(201,40,111,0.15)]"
        >
          <ToolBtn testid={`sticker-rotate-left-${sid}`} label="Rotate left" onClick={() => data.onRotate(sid, -15)}>
            <RotateCcw className="w-4 h-4" />
          </ToolBtn>
          <ToolBtn testid={`sticker-rotate-right-${sid}`} label="Rotate right" onClick={() => data.onRotate(sid, 15)}>
            <RotateCw className="w-4 h-4" />
          </ToolBtn>
          <span className="w-px h-5 bg-[#F5D0E3] mx-1" />
          <ToolBtn testid={`sticker-delete-${sid}`} label="Remove sticker" onClick={() => data.onDelete(sid)} danger>
            <Trash2 className="w-4 h-4" />
          </ToolBtn>
        </div>
      </NodeToolbar>
      <div
        className="w-full h-full drop-shadow-[0_4px_6px_rgba(59,35,80,0.18)] transition-transform duration-200"
        style={{ transform: `rotate(${data.rotation || 0}deg)` }}
      >
        <StickerArt kind={data.kind} />
      </div>
    </div>
  );
}

export default memo(StickerNode);
